import "./es.array.join-c1bca812.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.entries-d2a19275.js";
import { c } from "./index-8b07dec9.js";
import D, { useRef as q, useState as F, useEffect as P } from "react";
import T, { styled as j, css as d } from "styled-components";
import "./es.object.keys-9d66766f.js";
import { QUERIES as G } from "@ucl/shared-component-foundations";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as J } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as K } from "./useWindowSize.js";
import { _ as X } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import { _ as L } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import { useMediaQuery as Y } from "./useMediaQuery.js";
import { Tooltip as Z } from "./tooltip.js";
import { jsx as g, jsxs as Q } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-method-is-strict-e5a3c878.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-to-array-0474b7e7.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./es.parse-float-020a2ae0.js";
import "./string-trim-14e37ad3.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./uniqueId.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./es.string.starts-with-a6645e0a.js";
var E = ["leftIcon", "label", "ariaLabel", "dataTestId", "className", "_itemIndex", "value", "_onChange", "isDisabled"], A, M, R, $ = j.button(A || (A = L([`
  &.SegmentControlItem {
    `, `;
  }
`])), function(o) {
  var t = o.theme.components.segmentControl;
  return d(t.SegmentControlItem);
}), tt = j.label(M || (M = L([`
  &.SegmentControlItem__label {
    `, `;
  }
`])), function(o) {
  var t = o.theme.components.segmentControl;
  return d(t.SegmentControlLabel);
}), et = j.div(R || (R = L([`
  &.SegmentControlItem__icon {
    `, `;
  }
`])), function(o) {
  var t = o.theme.components.segmentControl;
  return d(t.SegmentControlItemIcon);
}), ot = function(t) {
  var p = t.leftIcon, m = t.label, N = t.ariaLabel, W = t.dataTestId, w = t.className, a = t._itemIndex, C = a === void 0 ? 0 : a, f = t.value, u = f === void 0 ? "" + (C + 1) : f, i = t._onChange, h = t.isDisabled, S = h === void 0 ? !1 : h, e = X(t, E), n = q(null), b = Y(G.mobile), v = F(!1), I = v[0], l = v[1];
  P(function() {
    if (n.current) {
      var r = n.current.scrollWidth > (n == null ? void 0 : n.current.clientWidth);
      l(r);
    }
  }, [m]);
  function _(r) {
    b && r.currentTarget.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    }), i == null || i(r, u, C);
  }
  return /* @__PURE__ */ g(Z, {
    className: "SegmentControlItem__Tooltip",
    "data-value": u,
    isDisabled: !I,
    title: m || "",
    placement: "auto",
    children: /* @__PURE__ */ Q($, Object.assign({}, e, {
      type: "button",
      value: u,
      onClick: _,
      "aria-label": N,
      "data-testid": W,
      disabled: S,
      className: c(["SegmentControlItem", {
        "SegmentControlItem--disabled": S,
        "SegmentControlItem--with-icon": p
      }, w]),
      children: [p && /* @__PURE__ */ g(et, {
        className: c(["SegmentControlItem__icon", "SegmentControlItem__icon--left"]),
        children: p
      }), /* @__PURE__ */ g(tt, {
        ref: n,
        className: c(["SegmentControlItem__label"]),
        children: m
      })]
    }))
  });
}, rt = /* @__PURE__ */ T.div.withConfig({
  displayName: "segmentControl__SegmentControlWrapper",
  componentId: "sc-1okzvre-0"
})(["&.SegmentControl-wrapper{", ";}"], function(o) {
  var t = o.theme.components.segmentControl;
  return d(t.SegmentControlWrapper);
}), nt = /* @__PURE__ */ T.div.withConfig({
  displayName: "segmentControl__StyledSegmentControl",
  componentId: "sc-1okzvre-1"
})(["&.SegmentControl{", ";}"], function(o) {
  var t = o.theme.components.segmentControl;
  return d(t.SegmentControl);
}), it = /* @__PURE__ */ T.div.withConfig({
  displayName: "segmentControl__SegmentIndicator",
  componentId: "sc-1okzvre-2"
})(["&.SegmentControl__indicator{", ";}"], function(o) {
  var t = o.theme.components.segmentControl;
  return d(t.SegmentIndicator);
}), lt = function(t) {
  var p = t.size, m = p === void 0 ? "medium" : p, N = t.className, W = t.children, w = t.onChange, a = t.activeItem, C = t.id, f = t.autoWidth, u = J({
    label: "SegmentControl"
  }), i = q(null), h = K(), S = h.width;
  return P(function() {
    var e = 0;
    if (i.current) {
      for (var n, b, v, I, l = i.current.parentElement, _ = i.current.querySelector(".SegmentControl__indicator"), r = i.current.querySelectorAll(".SegmentControlItem__Tooltip"), y = !0, x = 0, s = 0; s < r.length; s++) {
        var O;
        if (y && r[s].getAttribute("data-value") === a) {
          var k;
          e = s, x += ((k = r[s]) == null ? void 0 : k.offsetWidth) / 2, y = !1;
        }
        y && (x += (O = r[s]) == null ? void 0 : O.offsetWidth);
      }
      l != null && l.clientWidth && (l == null ? void 0 : l.clientWidth) < i.current.clientWidth && (i.current.setAttribute("style", "translate: calc(" + l.clientWidth / 2 + "px - " + x + "px)"), l.scrollLeft = 0);
      var H = {
        left: (n = r[e]) == null ? void 0 : n.offsetLeft,
        top: (b = r[e]) == null ? void 0 : b.offsetTop,
        width: (v = r[e]) == null ? void 0 : v.offsetWidth,
        height: (I = r[e]) == null ? void 0 : I.offsetHeight
      }, U = Object.entries(H).map(function(z) {
        var V = z[0], B = z[1];
        return V + ": " + B + "px";
      }).join("; ");
      _ == null || _.setAttribute("style", U);
    }
  }, [a, S, m]), /* @__PURE__ */ g(rt, Object.assign({
    className: c(["SegmentControl-wrapper"])
  }, u, {
    children: /* @__PURE__ */ Q(nt, {
      id: C,
      className: c(["SegmentControl", "SegmentControl--" + m, N]),
      ref: i,
      children: [/* @__PURE__ */ g(it, {
        className: "SegmentControl__indicator"
      }), D.Children.map(W, function(e, n) {
        return /* @__PURE__ */ D.cloneElement(e, {
          _onChange: w,
          _itemIndex: n,
          key: (e == null ? void 0 : e.props.label) || n,
          className: c([e == null ? void 0 : e.props.className, "SegmentControlItem--" + m, {
            "SegmentControlItem--active": !(e != null && e.props.isDisabled) && (a === (e == null ? void 0 : e.props.value) || a === "" + (n + 1)),
            "SegmentControlItem--auto-width": f
          }])
        });
      })]
    })
  }));
};
lt.Item = ot;
export {
  lt as SegmentControl
};
